module.exports = "<p>authenticate works!</p>\n"